import File from "@/scripts/models/file.model";
import Project from "@/scripts/models/project.model";
export default class Volunteering {

    constructor() {
        this.id = 0;
        this.fullName = '';
        this.shortName = '';
        this.tags = '';
        this.causeId = null;
        this.targetAudienceId = null;
        this.volunteeringTypeId = 0;     
        this.beneficiaries = 0;
        this.about = '';
        this.activities = '';
        this.initialFinalDates = [];
        this.initialDate = '';
        this.finalDate = '';
        this.institutionId = null;
        this.project = new Project();
        this.published = false;

        // Quem e avisado a cada vaga PUBLICADA neste voluntariado (AUC-134). Vazio -- o
        // normal -- nao notifica ninguem. Fica aqui, e nao na vaga, porque e a mesma
        // gente acompanhando a abertura de todas as vagas da instituicao.
        this.publicationNotificationEmails = null;

        this.ageRangeList = [];
        this.volunteeringCoverages = [];
        this.volunteeringVolunteeringTypes = [];
        this.scheduleList = [];
        this.goalList = [];
        this.newsList = [];
        this.followerList = [];

        this.documentsCheck = 0;
        this.newsCheck = 0;
        this.galleryCheck = 0;
        this.scheduleCheck = 0;

        this.stepsValidationStatus = {};
        
        this.faviconFile = new File();
        this.metaTitle = "";
        this.metaDescription = "";
    }
}